import { Link } from '@remix-run/react'
import Menu from './menu.tsx'
import { type RootOutletContext } from '~/root.tsx'

export default function Header({
	scrollContext,
}: {
	scrollContext: RootOutletContext
}) {
	return (
		<header className="relative flex h-[382px] min-h-[20vh] flex-col space-y-12 border-b-2 border-black bg-background p-6 pb-2 md:h-[300px]">
			<div className="relative z-20 flex flex-col pt-24 text-center font-title uppercase  text-gray-900 md:pt-28">
				<Link to="/" className="text-5xl md:text-6xl">
					Via Nova
				</Link>
			</div>
			<Menu scrollContext={scrollContext} />
		</header>
	)
}
